import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { SignatureAdvisorWidget } from "@/components/signature-advisor/SignatureAdvisorWidget";
import { useSiteBranding } from "@/context/SiteContext";

export default function SignatureAdvisorPage() {
  const { buildBrandedPath, isAgentPath } = useSiteBranding();

  return (
    <div className="pb-24 pt-0 md:pb-12 md:pt-4" data-testid="signature-advisor-page">
      <div className="mx-auto max-w-6xl">
        <div className="px-4 pt-4 md:px-0 md:pt-0">
          <Link className="inline-flex items-center gap-2 text-sm font-semibold text-[#8b6d16] transition hover:text-[#001935]" data-testid="signature-advisor-page-back-link" to={buildBrandedPath("/") }>
            <ArrowLeft className="h-4 w-4" /> Back to {isAgentPath ? "Portal" : "Home"}
          </Link>
        </div>
        <div className="mt-4 md:rounded-[34px] md:border md:border-[#D4AF37]/18 md:bg-[linear-gradient(135deg,#fffaf1_0%,#f5eedf_58%,#efe2c9_100%)] md:p-6 md:shadow-[0_24px_80px_rgba(0,25,53,0.08)]" data-testid="signature-advisor-page-shell">
          <div className="mb-4 flex flex-wrap items-start justify-between gap-4 px-1">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#8b6d16]" data-testid="signature-advisor-page-kicker">Analyst Environment</p>
              <h1 className="mt-2 text-3xl font-semibold text-[#001935] md:text-4xl" data-testid="signature-advisor-page-heading">The Signature Advisor</h1>
              <p className="mt-3 max-w-3xl text-sm leading-7 text-[#42566f]" data-testid="signature-advisor-page-copy">A dedicated full-screen workspace for deeper district analysis, investment memos, scenario testing, and concierge routing.</p>
            </div>
          </div>
          <SignatureAdvisorWidget forceRouteExperience />
        </div>
      </div>
    </div>
  );
}